import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import { PinModel } from "../Model/PinModel";

export type GGPinControlProps = PropsWithChildren<{
  digits: Array<PinModel>;
  bgStyle?: any;
  isEditable?: boolean;
  roundeStyle?: any;
  textColor?: string;
  boxSize?: number;
  alignControl?: any;
  activeColor?: string;
  activeIndex?: number;
  isSecure?: boolean;
  onEnterDigit?: (index: number, digit: string, ref: any) => void;
  onBackPressed?: (index: number, digit: string) => void;
}>;

function GGPinControl(props: GGPinControlProps): JSX.Element {
  const [digits, setDigits] = useState(props.digits ?? []);
  const otpRef1 = useRef<any | null>(null);

  const getStyle = (index: number) => {
    const defaultStyle = {
      height: props.boxSize ?? 45,
      width: props.boxSize ?? 45,
      color: props.textColor ?? "white",
      //   fontFamily: GGFonts.kGGBoldFont,
      fontSize: 35,
    };
    const combinedStyle = {
      ...defaultStyle,
      ...(props.roundeStyle ?? {}),
    };
    return combinedStyle;
  };

  useEffect(() => {
    setDigits(props.digits ?? []);
    setTimeout(() => {
      otpRef1?.current?.select();
    }, 10);
  }, [props.digits ?? []]);

  return (
    <div
      className="verify-otp1"
      style={{
        display: "flex",
        columnGap: 10,
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {digits.map((digit, index) => {
        return (
        
            <div key={index}>
              {/* <form autoComplete="off"> */}
                <input
                  key={`input-pin-${index}`}
                  autoComplete="off"
                  list="autocompleteOff"
                  aria-autocomplete="none"
                  autoCorrect="false"
                  ref={digit?.isActive ? otpRef1 : null}
                  inputMode={"numeric"}
                  disabled={false}
                  value={digit?.digit || ""}
                 // defaultValue={digit.digit}
                  type={props?.isSecure ? "password" : "text"}
                  style={getStyle(index)}
                  placeholder={""}
                  id={`input-pin-${index}`}
                  onFocus={(event) => {
                    setTimeout(() => {
                      event.target.select();
                    }, 10);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && digit?.digit?.length === 0) {
                      //console.log(index);
                      if (props.onBackPressed) {
                        props.onBackPressed(index, "");
                      }
                    } else {
                      digit.digit = "";
                    }
                  }}
                  onInput={(event: any) => {
                    if (event.target.value.length === 0) {
                      event.target.value = "";
                    } else {
                      event.target.value = Math.max(
                        0,
                        parseInt(event.target.value)
                      )
                        .toString()
                        .slice(0, 1);
                      if (props.onEnterDigit) {
                        props.onEnterDigit(index, event.target.value, otpRef1);
                      }
                    }
                  }}
                />
              {/* </form> */}
            </div>
         
        );
      })}
    </div>
  );
}

export default GGPinControl;
